import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cart-widget__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartItem = _resolveComponent("CartItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartCommodity, (cartCommodityItem) => {
      return (_openBlock(), _createBlock(_component_CartItem, {
        key: cartCommodityItem.key,
        product: cartCommodityItem.product,
        "item-key": cartCommodityItem.key,
        onRemove: ($event: any) => (_ctx.$.emit('remove', cartCommodityItem.key, cartCommodityItem.product))
      }, null, 8, ["product", "item-key", "onRemove"]))
    }), 128))
  ]))
}